import { useCallback, useEffect, useState } from "react";
import { WidthFormControl } from "../../../../models/models";
import SearchSprite from "./Img/serch_input_sprite.svg";
import "./SearchInput.scss";
import ImageSprite from "../../ImageSprite/ImageSprite";

export type SearchInputValueHandler = (value: string | undefined) => void;
export type SearchInputResetHandler = () => void;

enum ViewStateSearchInput {
    DEFAULT = "default",
    EDIT = "edit",
    ACTIVE = "active",
}

export type InputSearchProps = {
    placeholder?: string;
    value?: string;
    valueHandler: SearchInputValueHandler;
    widthFormControlWidth?: WidthFormControl;

    label?: string;
    name?: string;
};

const SearchInput = ({
    value,
    name,
    label,
    placeholder,
    valueHandler,
    widthFormControlWidth,
}: InputSearchProps) => {
    const [isElementFocused, setIsElementFocused] = useState(false);
    const [valueInput, valueInputHandler] = useState("");
    const [viewState, setViewState] = useState<ViewStateSearchInput>(
        ViewStateSearchInput.DEFAULT
    );

    useEffect(() => {
        if (valueInput.length === 0) {
            resetInputHandler()
        }
    }, [valueInput, setViewState])

    const handleFocusChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            if (event.type === "focus") {
                setViewState(ViewStateSearchInput.EDIT);
                setIsElementFocused(true);
            } else if (event.type === "blur") {
                setViewState(ViewStateSearchInput.DEFAULT);
                setIsElementFocused(false);
            }
        },
        []
    );

    const resetInputHandler = useCallback((): void => {
        setIsElementFocused(false);
        valueInputHandler("");
        valueHandler(undefined);
        setViewState(ViewStateSearchInput.DEFAULT);
    }, [valueHandler]);

    const handleKeyDown = useCallback(
        (event: React.KeyboardEvent<HTMLInputElement>) => {
            if (event.key === "Enter") {
                setIsElementFocused(true);
                setViewState(ViewStateSearchInput.ACTIVE);
                valueHandler(valueInput);
            }
        },
        [valueHandler, valueInput]
    );

    const actionButtonHandler = useCallback(() => {
        if (valueInput.length > 0) {
            valueHandler(valueInput);
            setViewState(ViewStateSearchInput.ACTIVE);
        }

    }, [resetInputHandler, valueHandler, valueInput, viewState])
    return (
        <div
            className={`form_control search_input  ${isElementFocused ? "focus" : ""}`}>
            <label className="label" htmlFor={name}>
                {label}
            </label>

            <input
                name={name}
                value={valueInput}
                type="text"
                className="form_control__input"
                placeholder={placeholder}
                onKeyDown={(e) => {
                    handleKeyDown(e);
                }}
                onBlur={(e) => {
                    handleFocusChange(e);
                }}
                onFocus={(e) => {
                    handleFocusChange(e);
                }}
                onChange={(e) => {
                    e.preventDefault();
                    valueInputHandler(e.target.value);
                }}
            />

            {valueInput.length > 0 &&
                <button
                    className="action_button action_button__clean"
                    type="button"
                    disabled={!valueInput.length}
                    onClick={() => resetInputHandler()}
                >
                    <ImageSprite iconSprite={`${SearchSprite}#clean`} />
                </button>
            }

            <button
                className="action_button"
                type="button"
                disabled={!valueInput.length}
                onClick={() => actionButtonHandler()}
            >
                <ImageSprite iconSprite={`${SearchSprite}#search`} />
            </button>
        </div>
    );
};

export default SearchInput;
